<template>
  <div :id="'logistic-map-container-' + id" class="logistic-map-container">
    
  </div>
</template>

<script>
import GoogleMapsLoader from "google-maps";
import axios from "axios";

export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    polygons: {
      type: Array
      //required: true
    }
  },
  data() {
    return {
      elementId: 'logistic-map-container-' + this.id,
      // mapPolygons: this.polygons,
      allPolygons: [],
      polygonPaths: [],
      fileCompare: null,
      name: "",
      drawingManager: null,
      drawingPolygons: [], 
      google: null,
      map: null
    };
  },
  watch: {
    polygons(newVal, oldVal) {
      
      console.log('watch polygons',newVal.length);
      // if (newVal !== oldVal) {
      //   this.mapPolygons = newVal;
      // }
      // if (this.mapPolygons.length === 0) {
      //   this.allPolygons = [];
      // }
      if (newVal.length === 0) {
        // console.log(this.polygonPaths)
        this.fileCompare = null;
        try {
          for (let p of this.polygonPaths) {
            p.setMap(null);
          }
        
          for (let p of this.drawingPolygons) {
            p.setMap(null);
          }
        } catch (e) {
        }
        
        this.polygonPaths = [];
        this.drawingPolygons = [];
        this.allPolygons = [];
        
        // this.initDrawing();
        
      } else { 
        if (this.fileCompare !== newVal) {
          // 如果沒變就不用重新畫
           
          // this.polygonPaths = newVal;
          this.drawingPolygons = newVal;
          // this.allPolygons = newVal;
          this.fileCompare = newVal;

          // 載入KML, 並且需要卡控...否則會loop...
          this.getPolygons();
        } else {
          console.log('the same');
        }
        
      }
    }, 
    // allPolygons(newVal, oldVal){
    //   // console.log('watch allPolygons', newVal)
    //   if (newVal.length === 0) {
    //     // console.log(this.polygonPaths)
    //     for (let p of this.polygonPaths) {
    //       p.setMap(null);
    //     }
       
    //     for (let p of this.drawingPolygons) {
    //       p.setMap(null);
    //     }
    //     this.polygonPaths = [];
    //     this.drawingPolygons = [];
        
    //     // this.initDrawing();
        
    //   }
    // }
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  },
  methods: {

    initDrawing() {
      
      let self = this;
      let google = self.google;
      let map = self.map;
      self.drawingManager = new google.maps.drawing.DrawingManager({
        // drawingMode: google.maps.drawing.OverlayType.MARKER,
        // drawingMode: google.maps.drawing.OverlayType.CIRCLE,
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true, //false to hide drawing control
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [
            // google.maps.drawing.OverlayType.MARKER,
            // google.maps.drawing.OverlayType.CIRCLE,
            google.maps.drawing.OverlayType.POLYGON
            // google.maps.drawing.OverlayType.POLYLINE,
            // google.maps.drawing.OverlayType.RECTANGLE,
          ]
        },
        // markerOptions: {
        //   icon:
        //     "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
        // },
        circleOptions: {
          fillColor: "#fcba03",
          fillOpacity: 0.5,
          strokeWeight: 5,
          clickable: false,
          editable: true,
          zIndex: 1
        },
        polygonOptions: {
          fillColor: "#fcba03",
          fillOpacity: 0.5,
          strokeWeight: 5,
          clickable: false,
          editable: true,
          zIndex: 1
        }
      });

      // 畫完polygons, 回傳座標
      // let allPolygons = [];

      function showArrays(polygon) {
        let polygonPaths = [];
        // Since this polygon has only one path, we can call getPath() to return the
        // MVCArray of LatLngs.
        // const polygon = this;
        const vertices = polygon.getPath();

        // Iterate over the vertices.
        for (let i = 0; i < vertices.getLength(); i++) {
          const xy = vertices.getAt(i);
          // console.log("<br>" + "Coordinate " + i + ":<br>" + xy.lat() + "," + xy.lng());
          polygonPaths.push({
            x: xy.lat(),
            y: xy.lng()
          });
          // polygonPaths.push([
          //   xy.lat(), xy.lng()
          // ]);
          
        }
        // 要close多邊形
        const xyo = vertices.getAt(0);
        polygonPaths.push({
          x: xyo.lat(),
          y: xyo.lng()
        });
        // polygonPaths.push([
        //   xyo.lat(), xyo.lng()
        // ]);
        console.log('-----------polygonPaths------------\n' + JSON.stringify(polygonPaths));
        self.allPolygons.push(polygonPaths)
        console.log('-----------allPolygons------------\n' + JSON.stringify(self.allPolygons));

        self.$emit("updated", self.allPolygons);
      }

      google.maps.event.addListener(
        self.drawingManager,
        "polygoncomplete",
        function(polygon) {
          // var paths = polygon.getPaths();
          self.drawingPolygons.push(polygon);
          showArrays(polygon);
          //self.drawingPolygon = polygon;
        }
      );

      // google.maps.event.addListener(
      //   self.drawingManager, 
      //   'overlaycomplete', 
      //   function(e) {
      //     // drawing polygon instance
      //     self.drawingPolygons.push(e.overlay);
      // });
      self.drawingManager.setMap(map);
    },
    // getPolygonCenter (polygonCoords){
    //   console.log('getpolygonCenter', polygonCoords)
    //   var bounds = new google.maps.LatLngBounds();
    //   var i;

    //   // The Bermuda Triangle
    //   // var polygonCoords = [
    //   //   new google.maps.LatLng(25.774252, -80.190262),
    //   //   new google.maps.LatLng(18.466465, -66.118292),
    //   //   new google.maps.LatLng(32.321384, -64.757370),
    //   //   new google.maps.LatLng(25.774252, -80.190262)
    //   // ];

    //   for (i = 0; i < polygonCoords.length; i++) {
    //     bounds.extend(polygonCoords[i]);
    //   }

    //   // The Center of the Bermuda Triangle - (25.3939245, -72.473816)
    //   console.log(bounds.getCenter());
    //   return bounds.getCenter()
    // },
    getPolygons() {
      this.triggerFromGet = true;
      let self = this;
      // console.log('------------default mapPolygons ----- \n' + JSON.stringify(self.polygons));
      GoogleMapsLoader.KEY = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
      GoogleMapsLoader.LIBRARIES = ["drawing"];
      let center = { lat: 25.0593739, lng: 121.5445842 }; // default
      let polygons = self.polygons;
      if (polygons && polygons.length) {
        let p = polygons[0]
        // get first location of 1 polygon
        let cenPoint1 = p[Object.keys(p)[0]];
        console.log("center ", cenPoint1);
        center = { lat: cenPoint1.x, lng: cenPoint1.y };
      }

      GoogleMapsLoader.load(function(google) {
          self.google = google;
          // if (polygons && polygons.length) {
          //   let path = [];
          //   for (let c of polygons[0]) {
          //     path.push(new google.maps.LatLng(c.x, c.y));
          //   }
          //   let cenPoint1 = self.getPolygonCenter(path);
          //   console.log("center ", cenPoint1);
          //   center = { lat: cenPoint1.lat(), lng: cenPoint1.lng() };
          // }

          
          var options = {
            // center: { lat: 25.0593739, lng: 121.5445842 }, // 如果有畫了多邊形，應該要根據這個拉到中心
            center: center,
            zoom: 15, //16
            //Disable Satellite option:
            mapTypeControl: false,
            //Disable street view.
            streetViewControl: false

          };

          var map = new google.maps.Map(
            //document.getElementById("polygon-map"),
            document.getElementById(self.elementId),
            options
          );
          self.map = map;

          // var marker = new google.maps.Marker({
          //   position: center,
          //   map: map,
          //   title: 'Test marker',
          //   label: {
          //     color: 'black',
          //     fontWeight: 'normal',
          //     text: 'Test marker label',
          //   },
          //   icon: {
          //     path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
          //     scale: 5,
          //     fillColor: 'blue',
          //     fillOpacity: 0.3,
          //     strokeWeight: 0.5
          //   }
          // });
          // 如果有現有的，就要清空才能畫
          self.initDrawing(google);
          if (polygons && polygons.length) {
            // 如果有既有的多邊形，可以畫出來？
            // 建立多邊形
            
            for (let i = 0; i < polygons.length; ++i) {
              try {
                let path = [];
                for (let c of polygons[i]) {
                  //path.push({ lat: c.x, lng: c.y});
                  path.push(new google.maps.LatLng(c.x, c.y));
                }
                let defaultPolygon = new google.maps.Polygon({
                  path: path,
                  strokeColor: "#bA0000",
                  strokeOpacity: 0.5,
                  strokeWeight: 5,
                  strokePosition: google.maps.StrokePosition.CENTER,
                  fillColor: "#f00",
                  fillOpacity: 0.35,
                  editable: false,
                });
                
                defaultPolygon.setMap(map);
                
                var overlay = { 
                  overlay: defaultPolygon, 
                  type: google.maps.drawing.OverlayType.POLYGON
                };
                self.polygonPaths.push(defaultPolygon);
                if (self.polygons.length) {
                  self.allPolygons = self.polygons;
                }
                
                //self.drawingPolygons.push(overlay);
                // let polygonPath = new google.maps.Polygon({
                //   path: path,
                //   strokeColor: "#bA0000",
                //   strokeOpacity: 0.5,
                //   strokeWeight: 5,
                //   strokePosition: google.maps.StrokePosition.CENTER,
                //   fillColor: "#f00",
                //   fillOpacity: 0.35,
                //   editable: false,
                //   // draggable: true, // 可以拖動位置
                //   map: map
                // });
                // self.polygonPaths.push(polygonPath);
              } catch (e) {}
            }
          }
          // else {
          //   // 繪圖相關
          //   // self.initDrawing(google);
          // }
        });
    }
  },
  mounted() {
    let self = this;
    const mapContainer = document.getElementById('logistic-map-container-'+self.id);
    let customMap = document.createElement('div')
    customMap.id = self.elementId;
    customMap.className = 'logistic-polygons';
    mapContainer.appendChild(customMap);

    self.getPolygons();

  }
};
</script>

<style>
.logistic-polygons {
  width: 100%;
  height: 100%;
}
.logistic-map-container {
  height: 100%;
  width: 100%;
}
/* @media screen and (max-width: 1024px) {
  .map-container {
    width: 100%;
  }
} */
</style>
